/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React from "react";
import PropTypes from "prop-types";
/* Component imports */

/* Style imports */
import "./styles.css";
/*** End Imports ***/

const ModalHeader = (props)=> {

    const onCrossClick = () => {
        props.onCrossClick();
    };

    return (
        <header className={"modal-header"}>
            {props.headerText}

            <i className="ck-icon _cross-circle"
                onClick={onCrossClick}
            />
        </header>
    );
};

ModalHeader.propTypes = {
    headerText: PropTypes.string.isRequired,
    onCrossClick: PropTypes.func.isRequired
};

export default ModalHeader;


// WEBPACK FOOTER //
// ./src/components/ModalHeader/ModalHeader.js